<template>
  <el-form
    :model="form"
    ref="form"
    class="dialog-form-default"
  >
  <!-- INVOICE -->
    <!-- title -->
    <div class="row">
      <div class="col-12">
        <h3 class="blue-text">{{L10n('invoice')}}</h3>
      </div>
    </div>
    <!-- content -->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice')"
          prop="invoiceID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-response-auto-complete
            :model.sync="form.invoiceID"
            @on-change="handleChangeInvoice"
            api="Invoices/GetAllDynamic"
            :selected="selectedInvoice"
            :fields="{id: 'id', title: 'invoiceNumber'}"
            :columns="columnsInvoice"
            :getLabel="getLabelInvoice"
            :orderBy="{fields: 'invoiceNumber'}"
            filters="invoiceTypeID == 3 || invoiceTypeID == 7"
            :templateFilter='(d) => `${d.fields.title}.StartsWith("${d.search}")`'
          >
          </select-response-auto-complete>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-number')"
          prop="invoiceNumber"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.invoiceNumber"
            @input="form.invoiceNumber = valueTrimLeft($event)"
            @change="autoSave('invoiceNumber', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-source')"
          prop="invoiceSourceID"
          class="material-style">
          <select-response
            :model.sync="form.invoiceSourceID"
            @on-change="(id, data) => autoSave('invoiceSourceID', { label: data && data.title })"
            :isLoading="dataSourceInvoiceSource.loading"
            :data="dataSourceInvoiceSource.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="companyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.companyID"
            @on-change="(id, data) => autoSave('companyID', { required: true, label: data && data.name })"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer-po')"
          prop="customerPO"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.customerPO"
            @input="form.customerPO = valueTrimLeft($event)"
            @change="autoSave('customerPO', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-date')"
          prop="invoiceDate"
          class="material-style"
        >
          <date-picker
            v-model="form.invoiceDate"
            @change="autoSave('invoiceDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-lg-5 col-md-6 col-4">
        <div class="price-field">
          <div class="price-field__field">
            <el-form-item
              :label="L10n('invoice-amount')"
              prop="invoiceAmount"
              class="material-style"
              :rules="getValidationRule('required,number')"
            >
              <el-input
                :value="form.invoiceAmount"
                @input="form.invoiceAmount = valueNumber($event)"
                @change="autoSave('invoiceAmount', { required: true })"
              />
            </el-form-item>
          </div>
          <div class="price-field__field">
            <el-form-item
              :label="L10n('vat-amount')"
              prop="invoiceVATAmount"
              class="material-style"
              :rules="getValidationRule('number')"
            >
              <el-input
                :value="form.invoiceVATAmount"
                @input="form.invoiceVATAmount = valueNumber($event)"
                @change="autoSave('invoiceVATAmount')"
              />
            </el-form-item>
          </div>
          <div class="price-field__value">
            <el-form-item
              :label="L10n('currency')"
              prop="currencyID"
              class="material-style">
              <select-response
                :model.sync="form.currencyID"
                @on-change="(id, data) => autoSave('currencyID', { label: data && data.title })"
                :isLoading="dataSourceCurrency.loading"
                :data="dataSourceCurrency.records"
              ></select-response>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('invoice-due-date')"
          prop="invoiceDueDate"
          class="material-style"
        >
          <date-picker
            v-model="form.invoiceDueDate"
            @change="autoSave('invoiceDueDate')"
          ></date-picker>
        </el-form-item>
      </div>
    </div>
  <!-- PAYMENT -->
    <!-- title -->
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-auto">
            <h3 class="blue-text">{{L10n('payment')}}</h3>
          </div>
          <div class="field-col col-auto">
            <el-form-item
              :label="L10n('payment-invoice-date')"
              class="material-style field"
            >
              <el-input
                :value="paymentInvoiceDate"
                readonly
              />
            </el-form-item>
          </div>
          <div class="col-auto">
            <el-form-item
              :label="L10n('payment-invoice-amount')"
              class="material-style field-warn-extra field"
            >
              <el-input
                :value="paymentInvoiceAmount"
                readonly
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('payment-date')"
          prop="paymentDate"
          class="material-style"
        >
          <date-picker
            v-model="form.paymentDate"
            @change="autoSave('paymentDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('payment-amount')"
          prop="paymentAmount"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.paymentAmount"
            @input="form.paymentAmount = valueNumber($event)"
            @change="autoSave('paymentAmount', { payloadData: {invoiceAmountForComm: valueNumber($event) }})"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('payment-method')"
          prop="methodID"
          class="material-style">
          <select-response
            :model.sync="form.methodID"
            @on-change="(id, data) => autoSave('methodID', { label: data && data.title })"
            :isLoading="dataSourceMethod.loading"
            :data="dataSourceMethod.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('payment-ok')"
          prop="paymentOK"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.paymentOK"
            @change="autoSave('paymentOK')">
          </el-checkbox>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3 col-12">
        <el-form-item
          :label="L10n('payment-bank')"
          prop="paymentBankID"
          class="material-style"
          :rules="getValidationRule('numberInteger')"
        >
          <select-response
            :model.sync="form.paymentBankID"
            @on-change="(id, data) => autoSave('paymentBankID', { label: data && data.title })"
            :isLoading="dataSourcePaymentBank.loading"
            :data="dataSourcePaymentBank.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-sm-9 col-12">
        <el-form-item
          :label="L10n('payment-remarks')"
          prop="paymentRemarks"
          class="material-style"
          :rules="getValidationRule('maxlength')"
        >
          <el-input
            v-model="form.paymentRemarks"
            @change="autoSave('paymentRemarks')"
          />
        </el-form-item>
      </div>
    </div>
  <!-- COMMISSIONS AND FEES  -->
    <template v-if="showCommissions">
      <!-- title -->
      <div class="row">
        <div class="col-12">
          <h3 class="blue-text">{{L10n('commissions-and-fees')}}</h3>
        </div>
      </div>
      <!-- content -->
      <div class="row">
        <div class="col-md-3 col-sm-6 col-12">
          <el-form-item
            :label="L10n('shipping-fees')"
            prop="paymentBank"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.orderShippingFees"
              @input="form.orderShippingFees = valueNumber($event)"
              @change="autoSave('orderShippingFees')"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
          <el-form-item
            :label="L10n('sales-commission')"
            prop="salesCommission"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.salesCommission"
              @input="form.salesCommission = valueNumber($event)"
              @change="autoSave('salesCommission')"
            />
          </el-form-item>
        </div>
        <div class="col-md-6 col-12">
          <el-form-item
            :label="L10n('commission-remarks')"
            prop="commRemarks"
            class="material-style"
            :rules="getValidationRule('maxlength')"
          >
            <el-input
              v-model="form.commRemarks"
              @change="autoSave('commRemarks')"
            />
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 col-12">
          <el-form-item
            :label="L10n('commission-invoice')"
            prop="commInvoice"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.commInvoice"
              @input="form.commInvoice = valueNumber($event)"
              @change="autoSave('commInvoice')"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
          <el-form-item
            :label="L10n('commission-invoice-date')"
            prop="commInvoiceDate"
            class="material-style"
          >
            <date-picker
              v-model="form.commInvoiceDate"
              @change="autoSave('commInvoiceDate')"
            ></date-picker>
          </el-form-item>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
          <el-form-item
            :label="L10n('invoice-amount-for-commission')"
            prop="invoiceAmountForComm"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.invoiceAmountForComm"
              @input="form.invoiceAmountForComm = valueNumber($event)"
              @change="autoSave('invoiceAmountForComm')"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
          <el-form-item
            :label="L10n('commission-invoice-paid')"
            prop="commInvoicePaid"
            data-filed="true"
            class="material-style">
            <el-checkbox
              v-model="form.commInvoicePaid"
              @change="autoSave('commInvoicePaid')">
            </el-checkbox>
          </el-form-item>
        </div>

        <div class="col-sm-6 col-12">
          <el-form-item
            :label="L10n('bax-cost-per-po')"
            prop="baxCostPerPO"
            class="material-style"
            :rules="getValidationRule('numberInteger')"
          >
            <el-input
              :value="form.baxCostPerPO"
              @input="form.baxCostPerPO = valueNumber($event)"
              @change="autoSave('baxCostPerPO')"
            />
          </el-form-item>
        </div>
        <div class="col-sm-6 col-12">
          <el-form-item
            :label="L10n('order-type')"
            prop="orderTypeCommissionID"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <select-response
              :model.sync="form.orderTypeCommissionID"
              @on-change="(id, data) => autoSave('orderTypeCommissionID', { label: data && data.title })"
              :isLoading="dataSourceOrderTypeCommission.loading"
              :data="dataSourceOrderTypeCommission.records"
            ></select-response>
          </el-form-item>
        </div>
      </div>
    </template>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { ServicePayments } from '@/services/Payments'

export default {
  name: 'FormGeneralPayments',
  mixins: [Form],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  props: {
    isNew: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    paymentInvoiceAmount () {
      return (this.form.paymentAmount || 0) - (this.form.invoiceAmount || 0)
    },
    paymentInvoiceDate () {
      const startDate = this.$moment(this.form.paymentDate ? new Date(this.form.paymentDate) : new Date())
      const endDate = this.form.invoiceDueDate ? new Date(this.form.invoiceDueDate) : new Date()
      return startDate.diff(endDate, 'days')
    },
    selectedInvoice () {
      return [
        'id', 'invoiceNumber', 'rfq.customerCompany.id as companyID', 'po as customerPO', 'invoiceDate', 'dueDate as invoiceDueDate',
        'vat.vatValue as vatValue', 'rfqid', 'invoiceType.title as invoiceTypeTitle'
      ].join(',')
    },
    columnsInvoice () {
      return [
        { title: this.L10n('invoice-number'), value: 'invoiceNumber' },
        { title: this.L10n('invoice-type'), value: 'invoiceTypeTitle', originField: 'invoice.invoiceType.title' }
      ]
    },
    showCommissions () {
      return this.permission(this.permissions, 'isAllowToViewCommissions')
    },
    permissions () {
      return this.$store.getters.get('permissions')
    },
    dataSourceInvoiceSource () {
      return this.API('InvoiceSources/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceMethod () {
      return this.API('Methods/GetAllDynamic?select=id,title')
    },
    dataSourceOrderTypeCommission () {
      return this.API('OrderTypeCommissions/GetAllDynamic?select=id,title&orderBy=id')
    },
    dataSourcePaymentBank () {
      return this.API('Banks/GetAllDynamic?select=id,title&filter=isActive==true&orderBy=id')
    }
  },
  methods: {
    getLabelInvoice (item) {
      return [item.invoiceNumber, item.invoiceTypeTitle].filter(Boolean).join(' - ')
    },
    async handleChangeInvoice (invoiceID, data) {
      if (!this.isNew) {
        return this.autoSave('invoiceID', { required: true, label: data && data.invoiceNumber })
      }

      if (!invoiceID) {
        return
      }

      try {
        this.$emit('update:isLoading', true)
        const { data: dataPayment } = await ServicePayments.getPaymentDataByInvoice({ invoiceID })

        this.form = { ...this.form, ...dataPayment }
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.$emit('update:isLoading', false)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .field-col {
    margin-left auto
  }
  .field {
    margin-bottom 0
    padding-bottom 1rem
  }
</style>
